import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { SITE, NAV } from "../lib/site";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-black/10"
    >
      <div className="container-soft flex items-center justify-between h-20">
        <Link to="/" data-testid="header-logo" className="flex flex-col leading-tight shrink-0">
          <span className="overline">Pompes Funèbres</span>
          <span className="font-serif-display text-xl sm:text-2xl tracking-tight whitespace-nowrap">
            Lumière des Nations
          </span>
        </Link>

        <nav className="hidden xl:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide whitespace-nowrap transition-colors duration-300 ${
                  isActive
                    ? "text-black border-b border-black pb-1"
                    : "text-neutral-600 hover:text-black"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={SITE.phoneHref}
            data-testid="header-call-button"
            className="hidden md:inline-flex items-center gap-2 bg-black text-white px-5 py-3 rounded-sm text-sm tracking-wide whitespace-nowrap hover:bg-neutral-800 transition-all duration-300 hover:-translate-y-0.5"
          >
            <Phone size={16} strokeWidth={1.5} />
            <span>{SITE.phone}</span>
          </a>
          <button
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
            className="xl:hidden p-2 -mr-2"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={24} strokeWidth={1.5} /> : <Menu size={24} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-nav" className="xl:hidden border-t border-black/10 bg-white">
          <div className="container-soft py-4 flex flex-col">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={({ isActive }) =>
                  `py-3 border-b border-black/5 text-sm ${
                    isActive ? "text-black" : "text-neutral-700"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <a
              href={SITE.phoneHref}
              data-testid="mobile-menu-call"
              className="mt-4 inline-flex items-center justify-center gap-2 bg-black text-white py-3 rounded-sm"
            >
              <Phone size={16} strokeWidth={1.5} /> {SITE.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
